<div class="container">
  <div class="logo"><img src="../../../assets/img/ibex-logo-text-new-new.png"/></div>
  <ng-container *ngIf="activeView === 'default'">
    <p>{{ 'login.login.loginTitle' | translate }}</p>

    <mat-form-field>
      <mat-label>{{ 'login.email' | translate }}</mat-label>
      <input (keydown.enter)="login()" [(ngModel)]="email" matInput name="email" autofocus>
    </mat-form-field>

    <password [(password)]="password" [placeholder]="('login.pw' | translate)"></password>

    <div class="failed" *ngIf="loginFailed">{{'login.failed' | translate}}</div>

    <mat-checkbox [(ngModel)]="rememberCredentials" name="rememberLogin">{{ 'login.login.remember' | translate }}</mat-checkbox>

    <div>
      <button (click)="login()" class="alternative-login" color="primary" mat-raised-button>{{ 'login.login.login' | translate }}</button>
      <div class="separator"><span class="text">{{ 'login.login.or' | translate }}</span></div>
      <button (click)="activeView = 'reset'" class="alternative-login" color="accent"
              mat-raised-button>{{ 'login.login.reset' | translate }}
      </button>
    </div>

    <p>{{ 'login.login.noAccount' | translate }}</p>

    <a href="mailto:welcome@ipeak.ch">
      <mat-icon>mail_outline</mat-icon>
      <span>welcome&#64;ipeak.ch</span>
    </a>
  </ng-container>

  <ng-container *ngIf="activeView === 'reset'">
    <p>{{ 'login.login.resetTitle' | translate }}</p>

    <mat-form-field>
      <input (keydown.enter)="forgotPassword()" [(ngModel)]="email" matInput name="email" placeholder="{{'login.email' | translate}}">
    </mat-form-field>

    <div>
      <button (click)="forgotPassword()" class="alternative-login" color="primary" mat-raised-button>
        {{ 'login.login.resetPw' | translate }}
      </button>
      <div class="separator"><span class="text">{{ 'login.login.or' | translate }}</span></div>
      <button (click)="activeView = 'default'" class="alternative-login" color="accent" mat-raised-button>
        {{ 'login.login.back' | translate }}
      </button>
    </div>

    <p>{{ 'login.login.resetNoEmail' | translate }}</p>

    <a href="mailto:welcome@ipeak.ch">
      <mat-icon>mail_outline</mat-icon>
      <span>welcome&#64;ipeak.ch</span>
    </a>
  </ng-container>
</div>
